import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import auth from "../../../auth";
import axios from "axios";

import { TabContent, TabPane, Nav, NavItem, NavLink, Table, Row, Button, Col, Label, Input, InputGroup, FormFeedback, Alert } from 'reactstrap';
import InputMask from 'react-input-mask';

import TableArchivos from './TableArchivos';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import CurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import AgregarCosto from "./AgregarCosto.js"

import DetailEmpresas from "../../clientes/Empresas/Detail.js"

import DetailLTA from "../../clientes/Responsables/Detail.js"

import dateFunctions from '../../functions/dateFunctions';

var columnStyle = {
    minWidth: "125px",
    maxWidth: "125px"
}

var columnStyleObs = {
    minWidth: "200px",
    maxWidth: "200px"
}
var FieldStyle = {
    maxWidth: "100%"
}

var TabHeaderStyle = {
    marginTop: '-15px',
    marginRight: '-15px',
    marginBottom: '0px',
    marginLeft: '-15px',
};

var TabHeaderBody = {
    marginTop: '0px',
    marginRight: '-15px',
    marginBottom: '-15px',
    marginLeft: '-15px',
};

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uvt_id: null,
            ott_id: null,
            solicitud_id: null,
            plan_id: null,
            condiciondepago_id: null,
            plazo_id: null,
            plazoDeEntrega_id: null,
            lae_id: null,
            empresa_id: null,
            motivo_id: null,
            costos: [],
            nro: 'P0000-00',
            nro: 'AA0000',
            valorReferencia: 0,
            ecuacion: "",
            coeficienteGC: 0,
            coeficienteUE: 0,
            ivaIncluido: 1,
            precioFinal: '',

            documentosFacturas: [],

            tabPresupuesto:1,
            e_array: [],

            e_alert: false,
            e_msj: '',

            obsPdf: true,
            presupuestoFormal: null,
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            uvt_id: null,
            ott_id: null,
            solicitud_id: null,
            plan_id: null,
            condiciondepago_id: null,
            plazo_id: null,
            plazoDeEntrega_id: null,
            lae_id: null,
            empresa_id: null,
            motivo_id: null,
            costos: [],
            nro: 'P0000-00',
            nro: 'AA0000',
            valorReferencia: 0,
            ecuacion: "",
            coeficienteGC: 0,
            coeficienteUE: 0,
            ivaIncluido: 2,
            precioFinal: '',

            documentosFacturas: [],

            tabPresupuesto:1,
            e_array: [],

            e_alert: false,
            e_msj: '',

            obsPdf: true,
            presupuestoFormal: null,
        })
    }

    setSelects(data) {
        if (data.allowed==true){
            this.setState({
                uvt_id: data.uvt_id,
                ott_id: data.ott_id,
                solicitud_id: data.solicitud_id,
                plan_id: data.plan_id,
                condiciondepago_id: data.condiciondepago_id,
                plazo_id: data.plazo_id,
                plazoDeEntrega_id: data.plazoDeEntrega,
                lae_id: data.lae_id,
                empresa_id: data.empresa_id,
                motivo_id: data.motivo_id,
                costos: data.costos,
                nro: data.nro,
                codigo: data.codigo,
                valorReferencia: data.valorReferencia,
                ecuacion: data.ecuacion,
                coeficienteGC: data.coeficienteGC,
                coeficienteUE: data.coeficienteUE,
                ivaIncluido: data.ivaIncluido,
                precioFinal: data.valorfinal,
                obsPdf: data.obsPdf,

                e_array: (data.etapasArray) ? (data.etapasArray.map((e)=>{e.valor = (e.valor.toString()).replace('.',','); return e})) : ([]),
                // documentosFacturas: (data.documentos) ? (data.documentos)  : ([]),

                // presupuestoFormal: (data.presupuestoFormal) ? (data.presupuestoFormal) : null,
            });
        }
    }

    onChangeInput(tabN, input) {
        var i = parseInt(tabN);
        var newCostos = this.state.costos;
        newCostos[i].value = input.value;
        this.setState({ costos: newCostos });
    }

    onChangeInputObs(tabN, input) {
        var i = parseInt(tabN);
        var newCostos = this.state.costos;
        newCostos[i].obs = input.value;
        this.setState({ costos: newCostos });
    }

    UpdateCostos(costos) {
        var newCostos = [];
        for (var i = 0; i < costos.length; i++) {
            var newCosto = costos[i];
            var oldCosto = this.state.costos.filter(x => x.pk == newCosto.pk);
            newCostos.push(
                {
                    pk: newCosto.pk,
                    nombre: newCosto.nombre,
                    value: (oldCosto.length > 0 ? oldCosto[0].value : 0),
                    obs: (oldCosto.length > 0 ? oldCosto[0].obs : ""),
                }
            );
        }
        this.setState({ costos: newCostos });
    }

    downloadPresupuestoFormal = () => {
        if (this.props.id && this.state.presupuestoFormal!=null) {
            window.open(api.proyectos.presupuesto.presupuestoformal.replace('$id_presupuesto', this.props.id()));
        }
    }

    render() {
        const { valorReferencia, precioFinal, documentosFacturas, tabPresupuesto, e_array, e_alert, e_msj, obsPdf, presupuestoFormal } = this.state;
        const redEtapas = (accumulator, currentValue) => accumulator + parseFloat(currentValue.valor.replace(/[.]/g, '').replace(',', '.')); //Reducer para calcular valor total de etapas

        var costoTotal = 0;
        var atr = [];

        if (this.state.costos) {
            let lastpk = 0;
            for (var i = 0; i < this.state.costos.length; i++) {
                let rowN = i.toString();
                var row = this.state.costos[i];
                costoTotal += parseFloat(row.value);
                atr.push(
                    <tr key={i}>
                        <th className="d-none" scope="row">
                            <Input type="number" name={"costos[" + rowN + "][id]"} className="p-0 d-none" value={row.pk} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                        </th>
                        <td className={(row.pk != lastpk ? "" : "border-0")} >
                            {(row.pk != lastpk ?
                                row.nombre
                                : "")}
                        </td>
                        <td className={(row.pk != lastpk ? "" : "border-0") + " " + "d-none d-sm-block"}>
                            <Input disabled={true} type="text" name={"costos[" + rowN + "][obs]"} value={row.obs} onChange={(e) => this.onChangeInputObs(rowN, e.target)} className="form-control text-left" />
                        </td>
                        <td className={(row.pk != lastpk ? "" : "border-0")}>
                            <Input disabled={true} type="text" name={"costos[" + rowN + "][valor]"} value={(row.value % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(row.value)) : (dateFunctions.formatCurrency(row.value))} onChange={(e) => this.onChangeInput(rowN, e.target)} className="form-control text-right" />
                        </td>
                    </tr>
                );
                lastpk = row.pk;
            }
        }


        var motivo;
        if (this.state.motivo) {
            motivo = (<Row className="mt-2">
                <Col className="col-12">
                    <Label>Motivo de Rechazo de Presupuesto</Label>
                    <ParadigmaAsyncSeeker value={this.state.motivo} fieldName={"motivo_id"} url={api.proyectos.config.presupuesto.motivos.select} disabled={true} />
                    <FormFeedback className="col-12"></FormFeedback>
                </Col>
            </Row>);
        }

        var subTotal = 0;
        return (
            <ParadigmaModal
                getUrl={api.proyectos.presupuesto.detail}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Presupuesto"}
                buttonTitle={"Ver Presupuesto"}
                buttonIcon={"fa fa-search fa-lg"}
                className={"ui-modal-dialog ui-modal-editor"}
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <div className="ui-form">
                <Nav tabs style={TabHeaderStyle}>
                    <NavItem>
                        <NavLink className={tabPresupuesto==1 ? 'active' : ''} onClick={() => { this.setState({tabPresupuesto:1}) }}>
                            Datos
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={tabPresupuesto==2 ? 'active' : ''} onClick={() => { this.setState({tabPresupuesto:2}) }}>
                            Pago
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={tabPresupuesto==3 ? 'active' : ''} onClick={() => { this.setState({tabPresupuesto:3}) }}>
                            Etapas
                        </NavLink>
                    </NavItem>
                    {/*<NavItem>
                        <NavLink className={tabPresupuesto==4 ? 'active' : ''} onClick={() => { this.setState({tabPresupuesto:4}) }}>
                            Archivos
                        </NavLink>
                    </NavItem>*/}
                </Nav>
                <TabContent style={TabHeaderBody} activeTab={tabPresupuesto} className={"py-2"}>

                    <TabPane tabId={1} className="py-0">

                    <Input type="hidden" name="plan_id" disabled={true} />
                    <ParadigmaLabeledInput
                        disabled
                        label={"Proyecto"}
                        fieldName=""
                        labelColumns={2}
                        fieldColumns={10}
                        inputComponent={
                            <Row noGutters>
                                <Col className="col-3 col">
                                    {this.state.codigo &&
                                        <InputMask disabled={true} className="form-control"  value={this.state.codigo} type="text" />
                                    }
                                </Col>
                                <Col className="col-9 col pl-5">
                                    <ParadigmaAsyncSeeker fieldName={"solicitud_id"}
                                        url={api.proyectos.solicitudes.select} value={this.state.solicitud_id} disabled={true} />
                                </Col>
                            </Row>
                        }
                    />

                    <ParadigmaLabeledInput
                        disabled
                        label={"Oficina de Transf. Técnica"}
                        fieldName=""
                        labelColumns={5}
                        fieldColumns={7}
                        inputComponent={
                            <ParadigmaAsyncSeeker disabled={true} fieldName={"ott_id"} url={api.proyectos.config.presupuesto.ott.select}
                                onChange={(e) => this.setState({ ott_id: e.pk })} value={this.state.ott_id} />
                        }
                    />


                    <ParadigmaLabeledInput
                        disabled
                        label={"Unidad de Vinculación"}
                        fieldName=""
                        labelColumns={5}
                        fieldColumns={7}
                        inputComponent={
                            <ParadigmaAsyncSeeker disabled={true} fieldName={"uvt_id"} url={api.proyectos.config.presupuesto.uvt.select}
                                onChange={(e) => this.setState({ uvt_id: e.pk })} value={this.state.uvt_id} />
                        }
                    />

                    <ParadigmaLabeledInput
                        disabled
                        label={"Nº de Presupuesto"}
                        fieldName="nro"
                        labelColumns={5}
                        fieldColumns={7}
                    />

                    <ParadigmaLabeledInput
                        disabled
                        label={"Empresa/Organización"}
                        fieldName=""
                        labelColumns={5}
                        fieldColumns={7}
                        inputComponent={
                            <ParadigmaAsyncSeeker Detail={DetailEmpresas} fieldName={"empresa_id"} url={api.clientes.empresas.select}
                                value={this.state.empresa_id} disabled={true} />
                        }
                    />

                    {
                        this.state.empresa_id &&
                        <ParadigmaLabeledInput
                            disabled
                            label={"Contacto del Cliente"}
                            fieldName=""
                            labelColumns={5}
                            fieldColumns={7}
                            inputComponent={
                                <ParadigmaAsyncSeeker Detail={DetailLTA} disabled={true} fieldName={"lae_id"} nombreField={"fullname"}
                                    url={api.clientes.responsables.select + "?empresa_id=" + this.state.empresa_id} value={this.state.lae_id} />
                            }
                        />
                    }

                    <ParadigmaLabeledInput
                        disabled
                        label={"Moneda de Pago"}
                        fieldName=""
                        labelColumns={5}
                        fieldColumns={7}
                        inputComponent={
                            <ParadigmaAsyncSeeker fieldName={"condiciondepago_id"} url={api.proyectos.config.presupuesto.condiciones.select}
                                value={this.state.condiciondepago_id} disabled={true} />
                        }
                    />

                    <Row className="mt-1">
                        <Col className="col-12">
                            <Table className="table-sm ui-cost-table">
                                <thead>
                                    <tr>
                                        <th className="d-none">#</th>
                                        <th className="col-3 align-middle">Costos</th>
                                        <th className="col-6 d-none d-sm-block" style={columnStyleObs}>
                                            <div className="d-inline-block w-50 align-middle">Obs</div>
                                        </th>
                                        <th className="col-3" style={columnStyle}>
                                            <div className="d-inline-block w-50 align-middle">Valor</div>
                                            <div className="d-inline-block text-right w-50"> </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {atr}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>


                    <ParadigmaLabeledInput disabled marginLeftAuto labelClassName="text-right" type={"number"}
                        label={"Costo del Proyecto"} fieldName="" labelColumns={8} fieldColumns={4} value={(costoTotal % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(costoTotal)) : (dateFunctions.formatCurrency(costoTotal))} />


                    <ParadigmaLabeledInput disabled marginLeftAuto labelClassName="text-right" type={"number"}
                        label={"Valor de Referencia"}
                        fieldName="" labelColumns={8} fieldColumns={4}
                        tooltipHeader={"Calculado con"}
                        tooltip={<div>
                            <div>V.R. = {this.state.ecuacion}</div>
                            <div>GC = {this.state.coeficienteGC}</div>
                            <div>UE = {this.state.coeficienteUE}</div>
                        </div>}
                        value={(valorReferencia % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(valorReferencia)) : (dateFunctions.formatCurrency(valorReferencia))} />


                    <ParadigmaLabeledInput disabled marginLeftAuto labelClassName="text-right" type={"number"}
                        label={"Precio"} style={{ fontWeight: 800 }} fieldName="valorfinal" labelColumns={8} fieldColumns={4} 
                        value={(precioFinal % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(precioFinal)) : (dateFunctions.formatCurrency(precioFinal))} />

                    <Row className="mt-3">
                        <input type={"hidden"} name="ivaIncluido" value={this.state.ivaIncluido} />
                        <Col className="row justify-content-end">
                            <Label className={"mr-4"}><input disabled type={"radio"} checked={this.state.ivaIncluido == 1} /> +IVA</Label>
                            <Label className={"mr-4"}><input disabled type={"radio"} checked={this.state.ivaIncluido == 2} /> IVA incluido</Label>
                            <Label className={""}><input disabled type={"radio"} checked={this.state.ivaIncluido == 3} /> Exento</Label>
                        </Col>
                    </Row>

                </TabPane>
                <TabPane tabId={2} className="py-0">

                    <ParadigmaLabeledInput
                        disabled
                        type={'textarea'}
                        rows={1}
                        label={"Forma de Pago"} 
                        fieldName="formaDePago"
                        labelColumns={3} fieldColumns={9} />

                    <ParadigmaLabeledInput
                        disabled
                        label={"Validez de Oferta"} 
                        fieldName="validezDeOferta"
                        labelColumns={3} fieldColumns={9} />

                    <ParadigmaLabeledInput
                        disabled
                        type={'textarea'}
                        rows={1}
                        label={"Plazo de Entrega"}
                        fieldName="plazoDeEntrega"
                        labelColumns={3} fieldColumns={9}
                        onChange={(e) => this.setState({ plazoDeEntrega_id: e.target.value })} 
                        value={this.state.plazoDeEntrega_id}
                    />
                    
                    <ParadigmaLabeledInput
                        disabled
                        label={"Observaciones para el presupuesto"}
                        type={"textarea"}
                        fieldName="obsPdf"
                        labelColumns={12} fieldColumns={12} 
                        onChange={(e) => this.setState({ obsPdf: e.target.value })} 
                        value={this.state.obsPdf}
                    />
                    {/* <input type={'hidden'} name="obsPdf" value={(obsPdf==true) ? ('True') : ('False')}/> */}

                    <ParadigmaLabeledInput disabled type={"textarea"}
                        label={"Observaciones internas"} fieldName="observaciones" labelColumns={12} fieldColumns={12} />

                    {this.state.motivo != 0 && motivo}
                
                    </TabPane>

                    {/* Etapas */}
                    <TabPane tabId={3} className="py-0">

                        {/*<Row className="mt-1">
                            <Col className="col-2"/>
                            <Col className="col-3">
                                <Label>Etapa N°</Label>
                                <Input type="number" className="text-right" value={(e_array.length+1)} disabled></Input>
                            </Col>
                            <Col className="col-4">
                                <Label>Valor</Label>                            
                                <CurrencyInput 
                                    placeholder={'0'}
                                    className={'monto'}
                                    selectOnFocus={true}
                                    style={{ fontWeight: 800, textAlign: 'right' }} 
                                    maskOptions={{includeThousandsSeparator: true, allowLeadingZeroes:true}}
                                    value={e_valor}
                                    onChange={d => this.setState({e_valor: d})}
                                    onBlur={() => this.setState({e_valor: (e_valor!=null && e_valor!='') ? (e_valor) : ('0')})}
                                    />
                            </Col>
                            <Col className="col-1 col px-0 p-relative">
                                <Button onClick={(e) => { e.preventDefault(); this.AddEtapa(); }} className="p-absolute bottom-0"><i className={"fa fa-plus"}></i></Button>
                            </Col>
                            <Col className="col-2"/>
                        </Row>*/}

                        <Row className="mt-1">
                            <Col className="col-12 my-2">
                                <Table className="table-sm t_etapas">
                                    <thead>
                                        <tr>
                                            <th width={50}></th>
                                            <th className={'text-center'} width={100}>Etapa N°</th>
                                            <th className={'text-center'} width={150}>Valor</th>
                                            <th className={'text-center'} width={150}>Subtotal</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            e_array.map(
                                            (etapa, i) =>
                                                <tr
                                                    key={i}
                                                >
                                                
                                            <td width={50}> </td>
                                                <td className={'text-center'} width={100}>{i+1}</td>
                                                <td className={'text-right pr-3'} width={150}>{dateFunctions.formatCurrency(parseFloat(etapa.valor.replace(/[.]/g, '').replace(',', '.')))}</td>
                                                <td className={'text-right pr-3'} width={150}>{dateFunctions.formatCurrency(subTotal+=parseFloat(etapa.valor.replace(/[.]/g, '').replace(',', '.')))}</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            (e_array.length==0) && <tr><td colSpan="3" className={'text-center'}>No hay etapas cargadas</td></tr>
                                        }
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th></th>
                                            <th colSpan={2}>Total</th>
                                            <th className={'text-right'}>
                                                {dateFunctions.formatCurrency(e_array.reduce(redEtapas, 0))}
                                            </th>
                                        </tr>
                                    </tfoot>
                                </Table>
                            </Col>
                        </Row>

                        <ParadigmaLabeledInput marginLeftAuto 
                            labelClassName="text-right" 
                            type={"number"}
                            label={"Precio"} 
                            style={{ fontWeight: 800 }} 
                            labelColumns={8} 
                            fieldColumns={4} 
                            inputComponent={
                                <CurrencyInput 
                                    disabled={true}
                                    placeholder={'0'}
                                    className={'monto'}
                                    selectOnFocus={true}
                                    style={{ fontWeight: 800, textAlign: 'right' }} 
                                    maskOptions={{includeThousandsSeparator: true, allowLeadingZeroes:true}}
                                    value={precioFinal}
                                    onChange={d => this.setState({precioFinal: d})}
                                    onBlur={() => this.setState({precioFinal: (precioFinal!=null && precioFinal!='') ? (precioFinal) : ('0')})}
                                    />
                            }/>

                        <Alert className={'my-2 text-center'} color="danger" isOpen={e_alert} toggle={()=>{this.setState({e_alert: !e_alert})}}>
                            {e_msj}
                        </Alert>

                    </TabPane>

                    {/*<TabPane tabId={4} className="py-0">
                        <Row className="mt-1">
                            <Col className="col-12">
                                <ParadigmaLabeledInput
                                    labelColumns={'auto'} 
                                    fieldColumns={9} 
                                    label={"Presupuesto Formal"}
                                    inputComponent={
                                        (presupuestoFormal) ?
                                        <Label onClick={()=>this.downloadPresupuestoFormal()} className={'xtDescarga'}>DESCARGAR</Label>
                                        :
                                        <Label onClick={()=>this.downloadPresupuestoFormal()}>No hay archivo cargado</Label>
                                    }
                                />
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col className="col-12">
                                <Label>Facturas</Label>
                                <TableArchivos
                                    action={'DETAIL'}
                                    archivos={documentosFacturas}
                                    // onChange={documentosFacturas => this.onChangeField('documentosFacturas', documentosFacturas)}
                                    onChange={data => this.setState({'documentosFacturas': data})}
                                    url={api.proyectos.presupuesto.documento.replace('$id_presupuesto', this.props.id())}
                                />
                            </Col>
                            <Input type="hidden" value={JSON.stringify(documentosFacturas)} name="documentosFacturas"></Input>
                        </Row>
                    </TabPane>*/}
                    </TabContent>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento3/Detail.js